import { orange, red, white } from 'core/styles';
import React from 'react';
import styled from 'styled-components';
import { processText } from 'core/utils/string';
import { web } from 'submodules/sharedText/flavor';

const { waitingRoom, actions } = web;
const flavor = { ...waitingRoom, ...actions };

const getBoxShadowBasedOnCount = (selectedPolls) => {
  if (!selectedPolls) return;
  return selectedPolls
    .map(({ color, triggered }, i) => {
      const width = triggered ? 1.5 : 1;
      return `inset ${i + width}em 0 ${color}`;
    })
    .join(', ');
};
export const Button = styled.button`
  @font-face {
    src: local('Gorey'), ur;(./fonts/Gorey.ttf) format('truetype');
  }
  font-family: Gorey;
  max-width: 300px; // TODO: revisit this styling
  min-width: 300px; // TODO: revisit this styling
  height: 2rem;
  font-size: 1.2rem;
  border-radius: 5px;
  border-color: ${orange};
  padding 0 0.625rem;
  border-radius: 5px;
  background-color: ${({ disabled, selected, backGroundColor }) =>
    disabled ? 'grey' : selected ? 'purple' : backGroundColor || red};
  color: ${({ color }) => color || white};
  &:active {
    background-color: ${orange};
  }
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }
  @media (min-width: 768px) {
    width: 400px;
  }
  box-shadow: ${({ selectedPolls }) => getBoxShadowBasedOnCount(selectedPolls)};
  transition: box-shadow 0.3s ease-in-out;
`;

export const StyledButton = styled(Button)`
  margin: 1rem 0 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const EndOfRoundButtons = ({
  startGame,
  startGameWithIntro,
  newGameAddPlayers,
  quitRound,
}) => {
  return (
    <ButtonWrapper>
      <StyledButton onClick={startGame}>
        {processText(flavor.startGame)}
      </StyledButton>
      <StyledButton onClick={startGameWithIntro}>
        {processText(flavor.startGame)}
      </StyledButton>
      <StyledButton onClick={newGameAddPlayers}>
        {processText(flavor.addPlayers)}
      </StyledButton>
      <StyledButton onClick={quitRound}>
        {processText(flavor.quit)}
      </StyledButton>
    </ButtonWrapper>
  );
};
